export default __webpack_public_path__ + "static/media/the-one-that-wont-decide.0e714fc2.png";